module.exports = __webpack_public_path__ + "static/media/distraction-cat.8aa4d849.png";